module.exports = __webpack_public_path__ + "static/media/historial-acad-mico.d62f7817.svg";